export default __webpack_public_path__ + "static/media/IbaneraBounce-White.e63cc6fb.gif";